import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { CloseOutlined } from '@ant-design/icons'
import { Modal, Button } from 'hljd'
import UploadField from '@common/UploadField'
import style from './style.module.less'
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc'

const SortableList = SortableContainer(({ children }) => {
  return <div className={style.picturePanel}>{children}</div>
})

const SortableItem = SortableElement(({ children }) => children)

const PictureItem = ({ path, onClick }, index) => (
  <div className={style.pictureItem}>
    <div className={style.closeIcon} onClick={onClick}>
      <CloseOutlined
        style={{
          fontSize: 12
        }}
      />
    </div>
    <img className={style.picture} src={`${path}?imageView/1/w/200/h/140`} />
  </div>
)

@inject('centerStore')
@observer
export default class extends Component {
  sortEnd = ({ oldIndex, newIndex }) => {
    const { pictureListPreview } = this.props.store
    this.props.store.sortPicture(
      arrayMove(pictureListPreview, oldIndex, newIndex)
    )
  }
  render() {
    const {
      pictureList,
      pictureLength,
      addImageWarning,
      pictureListPreview,
      clearPreview,
      savePreview,
      deletePreviewPicture,
      uploadPicture,
      preLength,
      pictureLimit
    } = this.props.store

    const { isSingle } = this.props.centerStore
    return (
      <Modal
        title={
          <p>
            <span>{isSingle ? '单品' : '套餐'}图片</span>
          </p>
        }
        visible={!!pictureListPreview.length}
        width={752}
        height={557}
        maskClosable={false}
        onCancel={clearPreview}
        // onOk={savePreview}
        // okButtonProps={{
        //   disabled:
        //     preLength > pictureListPreview.length &&
        //     pictureList.length + preLength < pictureLimit
        // }}
        footer={
          <div className={style.footer}>
            <div className={style.left}>拖动图片调整排序</div>
            <div className={style.right}>
              {/* <div className={style.addImg}>
                添加图片({pictureLength + preLength}/{pictureLimit})
              </div>
              <div className={style.ok} onClick={savePreview}>确定</div> */}
              {pictureLength + preLength < pictureLimit ? (
                <UploadField onOk={uploadPicture} multiple={true}>
                  {({ provided }) => (
                    <Button {...provided} style={{ marginRight: 20 }}>
                      添加图片({pictureLength + preLength}/{pictureLimit})
                    </Button>
                  )}
                </UploadField>
              ) : (
                <Button onClick={addImageWarning}>
                  添加图片({pictureLength + preLength}/{pictureLimit})
                </Button>
              )}
              <Button
                type="primary"
                disabled={
                  preLength > pictureListPreview.length &&
                  pictureList.length + preLength < pictureLimit
                }
                onClick={savePreview}
              >
                确定
              </Button>
            </div>
          </div>
        }
      >
        {/* <div className={style.tips}>
          <p>你可以拖拽调换图片位置，改变图片显示排序。</p>
          {pictureLength + preLength < 50 ? (
            <UploadField onOk={uploadPicture} multiple={true}>
              {({ provided }) => <Button {...provided}>继续上传</Button>}
            </UploadField>
          ) : (
            <Button onClick={addImageWarning}>继续上传</Button>
          )}
        </div> */}

        <SortableList
          onSortEnd={this.sortEnd}
          axis="xy"
          hideSortableGhost={false}
        >
          {pictureListPreview.map((el, i) => (
            <SortableItem disabled={false} key={i} index={i}>
              <PictureItem
                path={el.content.media_path}
                onClick={() => deletePreviewPicture(i)}
              />
            </SortableItem>
          ))}
        </SortableList>
      </Modal>
    )
  }
}
